import { ContactDto } from '../../models';

export const validateContact = (item: ContactDto) => {
  const fields: (keyof ContactDto)[] = [];

  if (typeof item.nickname !== 'string') fields.push('nickname');
  if (item.name !== undefined && typeof item.name !== 'string') fields.push('name');
  if (item.lasName !== undefined && typeof item.lasName !== 'string') fields.push('lasName');
  if (typeof item.selectedCountry !== 'string') fields.push('selectedCountry');

  return { valid: fields.length === 0, fields };
};
